import React, { lazy } from 'react';
import { logger, metric } from '@fiverr-private/perseus';

export const lazyImport = (componentName, loader) =>
    lazy(async() => {
        try {
            return await loader();
        } catch (error) {
            reportLoadingError(componentName, error);

            return import(/* webpackChunkName: 'FallbackComponent' */'./FallbackComponent');
        }
    });

const reportLoadingError = (componentName, error) => {
    metric.count(`lazy_loading.fetch_error.${componentName}`);

    logger.error(error, {
        description: 'Failed to lazy load asset',
        componentName
    });
};
